import React from 'react';
import InfoIcon from '@atlaskit/icon/glyph/info';
import Tooltip from '@atlaskit/tooltip';
import './account-balance-label.scss';

export const ACCOUNT_CREDIT_BALANCE_TEXT = 'Account credit balance';
export const ACCOUNT_CREDIT_BALANCE_TOOLTIP_CONTENT =
  "When there's a negative balance on an invoice, the total value is credited back to the billing account and stored as the account credit balance. Any balance automatically applies to the next invoice.";
export const ACCOUNT_CREDIT_BALANCE_TOOLTIP_CONTENT_V2 =
  'Negative invoice balances are credited back to the billing account. This account credit balance automatically applies to the next invoice.';

export const AccountBalanceLabel = ({ version }: { version?: number }) => {
  return (
    <div className="account-credit-balance-label-ppc">
      <label>{ACCOUNT_CREDIT_BALANCE_TEXT}</label>
      <Tooltip
        content={version === 2 ? ACCOUNT_CREDIT_BALANCE_TOOLTIP_CONTENT_V2 : ACCOUNT_CREDIT_BALANCE_TOOLTIP_CONTENT}
        tag="span"
      >
        <InfoIcon size="small" label="" testId="account-credit-balance-info-icon" />
      </Tooltip>
    </div>
  );
};
